import React, { useState, useEffect } from "react";
import GenericList from "../components/GenericList";
// import { Switch } from "@mui/material"; // Usando Material-UI para el switch
import { obtenerOficinas, eliminarOficina } from "../services/oficinas.service";
import { ACTION_BUTTONS } from "../config/constants";
import { Modal as ModalAntd } from "antd";
import Modal from "../components/Modal";
// import OficinasForm from "../components/OficinasForm";

const Notificaciones = () => {
  const [oficinasList, setOficinasList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageSize, setCurrentPageSize] = useState(10);
  const [orderByField, setOrderByField] = useState("id");
  const [orderByDirection, setOrderByDirection] = useState("asc");
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalWidth, setModalWidth] = useState("450px");
  const [reload, setReload] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const { confirm } = ModalAntd;

  // Función para obtener los datos
  const fetchOficinas = async () => {
    const oficinasList = await obtenerOficinas();
    setOficinasList(oficinasList.data);
  };

  useEffect(() => {
    fetchOficinas();
  }, [currentPage, currentPageSize, orderByField, orderByDirection, reload]);

  const listColumns = [
    { title: "Titulo", field: "title" },
    { title: "Detalle", field: "detail" },
    { title: "Creado por", field: "createdBy" },
    { title: "Fecha", field: "created" },
  ];

  const listActionButtons = [ACTION_BUTTONS.DELETE];

  // const onCreateAction = () => {
  //   setModalTitle(`ALTA DE OFICINA`);
  //   setModalContent(
  //     <OficinasForm
  //       setIsVisibleModal={setIsVisibleModal}
  //       reload={reload}
  //       setReload={setReload}
  //       oficina={null}
  //     />
  //   );
  //   setIsVisibleModal(true);
  // };

  //   const onEditAction = (row) => {
  //     setModalTitle(
  //       <>
  //         <p>
  //           EDICIÓN DE OFICINA <b>{row.nombre}</b>
  //         </p>
  //       </>
  //     );
  //     setModalContent(
  //       <OficinasForm
  //         setIsVisibleModal={setIsVisibleModal}
  //         reload={reload}
  //         setReload={setReload}
  //         oficina={row}
  //       />
  //     );
  //     setModalWidth("450px");
  //     setIsVisibleModal(true);
  //   };

  const onDeleteAction = (row) => {
    confirm({
      title: <div style={{ textAlign: "center" }}>Eliminación de oficina</div>,
      content: (
        <div style={{ textAlign: "center" }}>
          ¿Estás seguro de eliminar la oficina?
        </div>
      ),
      okText: "Eliminar",
      cancelText: "Cancelar",
      icon: null, // Puedes agregar un ícono personalizado o dejarlo vacío
      okType: "default", // Cambia el estilo del botón Ok
      okButtonProps: {
        style: { float: "left" }, // Mover el botón Ok a la izquierda
      },
      cancelButtonProps: {
        style: { float: "right" }, // Mover el botón Cancel a la derecha
      },
      onOk() {
        return eliminarOficina(row.id).then(() => {
          setReload(!reload);
        });
      },
    });
  };

  return (
    <>
      <GenericList
        columns={listColumns}
        data={[]}
        actions={listActionButtons}
        addDisabled={true}
        // onCreateButtonClick={onCreateAction}
        // onEditAction={onEditAction}

        onDeleteAction={onDeleteAction}
        title="Notificaciones"
        onPageChange={(page) => {
          setCurrentPage(page + 1);
        }}
        onPageSizeChange={(pageSize) => {
          setCurrentPageSize(pageSize);
        }}
        onOrderChange={(order) => {
          setOrderByField(order[0]?.orderByField);
          setOrderByDirection(order[0]?.orderDirection);
          setReload(!reload);
        }}
      />
      <Modal
        title={modalTitle}
        open={isVisibleModal}
        setIsVisible={setIsVisibleModal}
        width={modalWidth}
      >
        {modalContent}
      </Modal>
    </>
  );
};

export default Notificaciones;
